import { formatDistanceToNow } from 'date-fns';

export function getFeedbackDate(dateString: string) {
  const date = Date.parse(dateString);
  return formatDistanceToNow(date, {
    includeSeconds: true,
    addSuffix: true,
  });
}
